import React, { useEffect, useState, useCallback, useRef } from 'react';
// import { MapContainer, TileLayer, Marker, Tooltip, Popup } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import L from 'leaflet';
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow
} from '@react-google-maps/api';
import routeslogo from './assets/routeslogo.png';
import shuttleIconImg from './assets/shuttle_icon.png';
import shuttleIconLeftToRightImg from './assets/shuttle_icon.png';
import shuttleIconRightToLeftImg from './assets/shuttle_icon_right_to_left.png';
import shuttleIconTopToBottomImg from './assets/shuttle_icon_top_to_bottom.png';
import shuttleIconBottomToTopImg from './assets/shuttle_icon_bottom_to_top.png';
import PillarIconImg from './assets/shuttle_stop_icon.png';
import locationIconImg from './assets/my_location_icon.png';
import destinationIconImg from './assets/destination_location_icon.png';
import { baseURL } from './backend_url';
import "./Dashboard.css"
import axios from 'axios';
import Select from "react-select";
import Swal from "sweetalert2";
import ReactDOMServer from 'react-dom/server'; // Import ReactDOMServer


// Left to Right
const CurvedArrowHeadLeftToRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
      {/* Curved arrowhead */}
      <path 
        className="blinking"
        d="M 15 10 Q 30 25 15 40 L 45 25 Z"
        fill="blue" 
      />

      <style>{`
        .blinking {
          animation: blink 1.5s infinite;
        }

        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0.2; }
          100% { opacity: 1; }
        }
      `}</style>
    </svg>
  );
}

const CurvedArrowHeadRightToLeft = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
      {/* Curved arrowhead pointing right to left */}
      <path 
        className="blinking"
        d="M 45 10 Q 30 25 45 40 L 15 25 Z"
        fill="blue" 
      />

      <style>{`
        .blinking {
          animation: blink 1.5s infinite;
        }

        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0.2; }
          100% { opacity: 1; }
        }
      `}</style>
    </svg>
  );
}

const CurvedArrowHeadUpToDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
      {/* Curved arrowhead pointing up to down */}
      <path 
        className="blinking"
        d="M 10 15 Q 25 30 40 15 L 25 45 Z"
        fill="blue" 
      />

      <style>{`
        .blinking {
          animation: blink 1.5s infinite;
        }

        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0.2; }
          100% { opacity: 1; }
        }
      `}</style>
    </svg>
  );
}

const CurvedArrowHeadDownToUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
      {/* Curved arrowhead pointing down to up */}
      <path 
        className="blinking"
        d="M 10 45 Q 25 30 40 45 L 25 15 Z"
        fill="blue" 
      />

      <style>{`
        .blinking {
          animation: blink 1.5s infinite;
        }

        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0.2; }
          100% { opacity: 1; }
        }
      `}</style>
    </svg>
  );
}

const getSVGDataUrl = (svg) => {
  const svgString = ReactDOMServer.renderToStaticMarkup(svg); // Convert to static markup
  const encodedData = encodeURIComponent(svgString);
  return `data:image/svg+xml;charset=utf-8,${encodedData}`;
};

const icons = {
  PillarIcon: {
    url: PillarIconImg,
    scaledSize: { width: 30, height: 40 }
  },
  locationIcon: {
    url: locationIconImg,
    scaledSize: { width: 30, height: 30 }
  },
  destinationIcon: {
    url: destinationIconImg,
    scaledSize: { width: 30, height: 30 }
  },
  // shuttleIcon: {
  //   url: shuttleIconImg,
  //   scaledSize: { width: 30, height: 40 }
  // },
  // shuttleIconLeftToRight: {
  //   url: shuttleIconLeftToRightImg,
  //   scaledSize: { width: 30, height: 40 }
  // },
  // shuttleIconRightToLeft: {
  //   url: shuttleIconRightToLeftImg,
  //   scaledSize: { width: 30, height: 40 }
  // },
  // shuttleIconTopToBottom: {
  //   url: shuttleIconTopToBottomImg,
  //   scaledSize: { width: 30, height: 40 }
  // },
  // shuttleIconBottomToTop: {
  //   url: shuttleIconBottomToTopImg,
  //   scaledSize: { width: 30, height: 40 }
  // }
  shuttleIcon: {
    url: getSVGDataUrl(<CurvedArrowHeadLeftToRight />),
    scaledSize: { width: 30, height: 30 }
  },
  shuttleIconLeftToRight: {
    url: getSVGDataUrl(<CurvedArrowHeadLeftToRight />),
    scaledSize: { width: 30, height: 30 }
  },
  shuttleIconRightToLeft: {
    url: getSVGDataUrl(<CurvedArrowHeadRightToLeft />),
    scaledSize: { width: 30, height: 30 }
  },
  shuttleIconTopToBottom: {
    url: getSVGDataUrl(<CurvedArrowHeadUpToDown />),
    scaledSize: { width: 30, height: 30 }
  },
  shuttleIconBottomToTop: {
    url: getSVGDataUrl(<CurvedArrowHeadDownToUp />),
    scaledSize: { width: 30, height: 30 }
  }
};

// Function to calculate the distance between two points
const getDistance = (point1, point2) => {
  const lat1 = point1.lat;
  const lng1 = point1.lng;
  const lat2 = point2.lat;
  const lng2 = point2.lng;
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLng = (lng2 - lng1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers
  return distance;
};

const VehicleTracker = (locationId) => {
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("690337");
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationName, setLocationName] = useState("Routes Car Rental");
  const [vehicleLocations, setVehicleLocations] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 28.4295, lng: -81.3089 }); // Default to MCO
  const [vehicleIcons, setVehicleIcons] = useState({}); // State to track icons for each vehicle
  const [veihcleDetail, setVehicleDetail] = useState([]);
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [fetchInterval, setFetchInterval] = useState(null);
  const [fetchTimeout, setFetchTimeout] = useState(null); // New state variable for timeout
  const [myLocation, setMylocation] = useState({ lat: 28.4295, lng: -81.3089 });
  const [showMap, setShowMap] = useState(false); // State to toggle map display
  const [routesLocationCord, setRoutesLocationCord] = useState({ lat: 28.461710, lng: -81.273550 });
  const [allTerminal, setAllTerminal] = useState([]);
  const [errorFlag, setErrorFlag] = useState(false)
  const prevVehicleLocationsRef = useRef([]);
  const [hashPlate, setHashPlate] = useState({});

  useEffect(() => {
    axios.get(baseURL + "/get_company_location/" + companyId)
      .then((res) => {
        axios.get(baseURL + "/srt_get_active_location/" + companyId.toString())
          .then((res1) => {
            let allTemp = res.data.res;
            let hashLocationNameId = {};
            allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
            setHashLocationNameVsID(hashLocationNameId);
            setLocationName(hashLocationNameId[locationId?.locationId])
            if (allTemp.length > 0) {
              let tempArr = [];
              for (let i = 0; i < allTemp.length; i++) {
                if (res1.data[allTemp[i].location_id] === true) {
                  tempArr.push(allTemp[i]);
                }
              }
              setLocationDetail(tempArr);
              setVehicleDetail([])
              setVehicleLocations([])
              setShowMap(false); // Reset showMap state when location changes
              if (fetchInterval) {
                clearInterval(fetchInterval);
                setFetchInterval(null);
              }
            }

            if (locationName) {
              setVehicleDetail([]);
              setVehicleLocations([]);
              setShowMap(false); // Reset showMap state when location changes
              if (fetchInterval) {
                clearInterval(fetchInterval);
                setFetchInterval(null);
              }
              console.log("--locationId--", locationId)
              axios
                .post(`${baseURL}/srt_get_terminals_pillars`, locationId)
                .then((response) => {
                  if (response.data.status === 'success') {
                    setAllTerminal(response.data.terminal_pillar);
                    setRoutesLocationCord({ lat: 1 * response.data.location_cod.lat, lng: 1 * response.data.location_cod.lng })
                    setHashPlate(response.data.hash_srt_plate_num)
                    setErrorFlag(false)
                  } else {
                    Swal.fire("Failed", "For this location, Terminals and Pillars data not present", "error");
                    setErrorFlag(true);
                  }

                })
                .catch((error) => {
                  Swal.fire("Failed", "For this location, Terminals and Pillars data not present", "error");
                  setErrorFlag(true);
                });
            }
          })
          .catch(error => console.error("Error fetching active locations:", error));
      })
      .catch(error => console.error("Error fetching company locations:", error));
  }, []);

  const fetchVehicleLocations = useCallback(() => {
    fetch(`${baseURL}/srt_vehicle_live_location/${locationId?.locationId}`)
      .then(response => response.json())
      .then(data => {
        const vehicleLocArr = data.map(({ lat, lng }) => ({ lat, lng }));

        setVehicleLocations(vehicleLocArr);
        setVehicleDetail(data);
        const updatedIcons = {};

        vehicleLocArr.forEach((vehicleLoc, index) => {
          let prevLoc = prevVehicleLocationsRef.current[index] || vehicleLocArr[index];

          let icon = icons.shuttleIcon; // Default icon
          const latDiff = vehicleLoc.lat - prevLoc.lat;
          const lngDiff = vehicleLoc.lng - prevLoc.lng;

          if (Math.abs(latDiff) > Math.abs(lngDiff)) {
            icon = latDiff > 0 ? icons.shuttleIconBottomToTop : icons.shuttleIconTopToBottom;
          } else {
            icon = lngDiff > 0 ? icons.shuttleIconLeftToRight : icons.shuttleIconRightToLeft;
          }

          updatedIcons[index] = icon;
        });

        setVehicleIcons(updatedIcons);

        // if (vehicleLocArr.length > 0) {
        //   const nearestVehicle = vehicleLocArr.reduce((nearest, vehicle) => {
        //     const distance = getDistance(mapCenter, vehicle);
        //     return distance < nearest.distance ? { location: vehicle, distance } : nearest;
        //   }, { location: null, distance: Infinity });

        //   setMapCenter(nearestVehicle.location);
        // }
        prevVehicleLocationsRef.current = vehicleLocArr;
      })
      .catch(error => console.error("Error fetching vehicle locations:", error));
  }, [baseURL, locationId?.locationId, mapCenter, vehicleLocations]);

  const handleShowButtonClick = () => {
    if (fetchInterval) {
      clearInterval(fetchInterval);
    }
    if (fetchTimeout) {
      clearTimeout(fetchTimeout);
    }
    setMapCenter(routesLocationCord)
    setShowMap(true); // Show map when button is clicked
    fetchVehicleLocations(); // Fetch immediately
    const interval = setInterval(fetchVehicleLocations, 5000);
    setFetchInterval(interval);

    // Set a timeout to stop the tracking after 20 minutes (1200 seconds)
    const timeout = setTimeout(() => {
      clearInterval(interval);
      setShowMap(false);
      setFetchInterval(null);
      // window.close();
    }, 900 * 1000);

    setFetchTimeout(timeout);
  };

  useEffect(() => {
    return () => {
      if (fetchInterval) {
        clearInterval(fetchInterval);
      }
      if (fetchTimeout) {
        clearTimeout(fetchTimeout);
      }
    };
  }, [fetchInterval, fetchTimeout]);

  useEffect(() => {
    // console.log("--vehicleLocations in useEffect--", vehicleLocations);
  }, [vehicleLocations]);

  const mapContainerStyle = {
    width: '100%',
    height: '700px'
  };


  const silverStyle = [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dadada" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#c9c9c9" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
  ];

  const options = {
    // disableDefaultUI: true,
    zoomControl: true,
    styles: silverStyle,
  };

  return (
    <div className="container mt-2">
      <div className="row p-1 bg-light rounded shadow-sm d-flex justify-content-center align-items-center">
        <img src={routeslogo} alt="Live Shuttle Tracking" style={{ width: '150px', height: 'auto' }} className="mx-auto" />
        <h4 className="text-primary mb-4 ms-3 d-flex justify-content-center align-items-center pt-3">Live Shuttle Tracking - {locationName}</h4>
        {companyName && (
          <>
            {locationName && !errorFlag && (
              <div className="mb-4 d-flex justify-content-center">
                <button className="btn btn-primary" onClick={handleShowButtonClick}>Show Live Shuttle Tracking</button>
              </div>
            )}
            <div className="mb-4">
              {showMap && locationName && (vehicleLocations.length > 0 ? (
                <LoadScript googleMapsApiKey="AIzaSyC36o4niEA5vZG4bMS0CM5FBQaKEt6QADw">
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={mapCenter}
                  zoom={14}
                  options={options}

                >
                  <Marker
                    position={routesLocationCord}
                    icon={icons.destinationIcon}
                    title="Routes Car Rental"
                  ><InfoWindow options={{
                    pixelOffset: { width: 0, height: -35 },

                  }}
                    position={routesLocationCord}

                  >
                      <div>
                        <div className='d-flex justify-content-center mb-1'><img src={routeslogo} alt="Live Shuttle Tracking" style={{ width: '50px', height: 'auto' }} className="mx-auto" /></div>
                        <div className='d-flex justify-content-center'><span style={{ color: 'green' }}><b>Routes {" " + locationId?.locationId?.split('-')[1]}</b></span> </div>
                      </div>
                    </InfoWindow>
                  </Marker>
                  {allTerminal.length > 0 && allTerminal.map((terminal) => terminal.pillars.map((pillar, index) => (
                    <Marker
                      key={index}
                      position={{ lat: 1 * pillar.latitude, lng: 1 * pillar.longitude }}
                      icon={icons.PillarIcon}
                      title={pillar.number}
                      label={{
                        text: pillar.number, // Text for the label
                        color: "black", // Text color
                        fontWeight: "bold", // Make the text bold
                        fontSize: "12px", // Adjust font size as needed
                      }}
                    >
                   
                    </Marker>
                  )))}
                  {vehicleLocations.map((location, index) => (

                    <Marker
                      key={index}
                      position={{ lat: location.lat, lng: location.lng }}
                      icon={(vehicleIcons[index])}
                      title={`Name: ${veihcleDetail[index]['name'] || 'Unknown'}`}

                    >
                      {/* <InfoWindow options={{ pixelOffset: { width: 0, height: -35 } }} position={{ lat: location.lat, lng: location.lng }} >
                        <div>
                          <span style={{ color: veihcleDetail[index].engineStatus ? 'blue' : "grey" }}>Name: {veihcleDetail[index]['name']}<br /></span>
                          <span style={{ color: veihcleDetail[index].engineStatus ? 'blue' : "grey" }}>Plate: {hashPlate[veihcleDetail[index]['externalIds']['samsara.serial']]}<br /></span>
                        </div>
                      </InfoWindow> */}
                    </Marker>
                  ))}
                </GoogleMap>
              </LoadScript>
              ) : (
                <div className="text-center mt-4">
                  {/* <p>Tracking not available for this location. Please contact support@routes.ca</p> */}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VehicleTracker;
